import { createFileRoute, redirect } from '@tanstack/react-router'

// The README of @uptrack-app/mcp named this address, and MCP directories copied it. It was a 404.
// public/robots.txt allows this path, so crawlers can follow the redirect. The target is public,
// and it says where a signed-in user creates an API key.
export const Route = createFileRoute('/dashboard_/api-keys')({
  beforeLoad: () => {
    throw redirect({ to: '/guides/mcp', hash: 'api-key', statusCode: 301 })
  },
  component: () => null,
})
